export default "__VITE_ASSET__CM41XIKa__"